<div class="container">
	<div class="container__header">
		<span class="container__title">{{ 'DRAWERS.SEARCH.TITLE' | translate }}</span>
		<form class="container__form" [formGroup]="searchForm">
			<form-row>
				<form-field>
					<lawyal-dropdown-input
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.ITEM.PLACEHOLDER'"
						[formControlName]="ITEM_CONTROL_NAME"
						[options]="itemOptions"
						[isSelectedOptionBold]="true"
						[isOptionsTitleCase]="false"
					>
					</lawyal-dropdown-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[placeholder]="'INPUTS.FREE_TEXT_INPUT.TEXT_PLACEHOLDER'"
						[formControlName]="SEARCH_TERMS_CONTROL_NAME"
					>
					</free-text-input>
				</form-field>
			</form-row>
		</form>
	</div>
	<div class="container__content">
		<ng-container #contentHost></ng-container>
	</div>
</div>
